var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useYesNoOptions, } from '../../clearstep/Types';
import SelectNative from '../../tailwind_common/SelectNative';
var NewPatientSelect = function (props) {
    var _a;
    var _b = useState(), defaultValue = _b[0], setDefaultValue = _b[1];
    useEffect(function () {
        var _a, _b;
        if (((_a = props.requestData) === null || _a === void 0 ? void 0 : _a.isNewPatient) === true) {
            setDefaultValue(yesNoOptions.Yes.value);
        }
        if (((_b = props.requestData) === null || _b === void 0 ? void 0 : _b.isNewPatient) === false) {
            setDefaultValue(yesNoOptions.No.value);
        }
    }, [(_a = props.requestData) === null || _a === void 0 ? void 0 : _a.isNewPatient]);
    var onSelect = function (option) {
        if (option === yesNoOptions.Yes.value) {
            props.setRequestData(__assign(__assign({}, props.requestData), { isNewPatient: true }));
        }
        else if (option === yesNoOptions.No.value) {
            props.setRequestData(__assign(__assign({}, props.requestData), { isNewPatient: false }));
        }
    };
    var yesNoOptions = useYesNoOptions();
    var required = props.required, prompt = props.prompt, placeholder = props.placeholder;
    return (React.createElement("div", { className: "w-75 min-w-fit max-w-75 mobile:w-full mobile:max-w-full" },
        React.createElement(SelectNative, { label: prompt, onSelect: onSelect, options: Object.values(yesNoOptions), required: required, placeholder: t('searchCareLocationsForm.select.placeholder', placeholder), defaultSelected: defaultValue })));
};
export default NewPatientSelect;
